"use strict";

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = delayTransitionRender;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _requestanimationframeTimer = require("requestanimationframe-timer");

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/delayTransitionRender.js";

function delayTransitionRender(WrappedComponent) {
  var DelayedTransitionWrapper = /*#__PURE__*/function (_react$Component) {
    _inherits(DelayedTransitionWrapper, _react$Component);

    var _super = _createSuper(DelayedTransitionWrapper);

    function DelayedTransitionWrapper(props) {
      var _this;

      _classCallCheck(this, DelayedTransitionWrapper);

      _this = _super.call(this, props);
      _this.state = {
        // if there is a delay, set shouldRender to false
        // then in componentdid mount shouldRender becomes true
        // after the delay.
        shouldRender: !!!_this.props.delay
      };
      return _this;
    }

    _createClass(DelayedTransitionWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.renderTimeout = (0, _requestanimationframeTimer.setTimeout)(function () {
          return _this2.setState({
            shouldRender: true
          });
        }, this.props.delay);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        (0, _requestanimationframeTimer.clearTimeout)(this.renderTimeout);
      }
    }, {
      key: "render",
      value: function render() {
        return this.state.shouldRender || typeof window === "undefined" ? /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30,
            columnNumber: 5
          }
        })) : null;
      }
    }]);

    return DelayedTransitionWrapper;
  }(_react.Component);

  return DelayedTransitionWrapper;
}